(function () {
  'use strict';

  function normalise(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function initialiseDirectory(directory) {
    if (directory.dataset.directoryInitialised === 'true') return;
    directory.dataset.directoryInitialised = 'true';

    var form = directory.querySelector('[data-directory-filters]');
    var categorySelect = directory.querySelector('[data-directory-category]');
    var locationInput = directory.querySelector('[data-directory-location]');
    var count = directory.querySelector('[data-directory-count]');
    var empty = directory.querySelector('[data-directory-empty]');
    var cards = Array.prototype.slice.call(directory.querySelectorAll('[data-directory-card]'));
    var categoryButtons = Array.prototype.slice.call(directory.querySelectorAll('[data-directory-category-button]'));
    var locationButtons = Array.prototype.slice.call(directory.querySelectorAll('[data-directory-location-button]'));

    if (!form || !categorySelect || !locationInput || !count || !empty) return;

    var categories = {};
    cards.forEach(function (card) {
      var label = String(card.dataset.category || '').trim();
      if (label) categories[normalise(label)] = label;
    });

    Object.keys(categories)
      .sort(function (a, b) { return categories[a].localeCompare(categories[b]); })
      .forEach(function (key) {
        var option = document.createElement('option');
        option.value = categories[key];
        option.textContent = categories[key];
        categorySelect.appendChild(option);
      });

    function updateButtonStates() {
      var selectedCategory = normalise(categorySelect.value);
      var selectedLocation = normalise(locationInput.value);
      categoryButtons.forEach(function (button) {
        button.classList.toggle('is-active', normalise(button.dataset.directoryCategoryButton) === selectedCategory);
      });
      locationButtons.forEach(function (button) {
        button.classList.toggle('is-active', normalise(button.dataset.directoryLocationButton) === selectedLocation);
      });
    }

    function updateDirectory(options) {
      var selectedCategory = normalise(categorySelect.value);
      var locationQuery = normalise(locationInput.value);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var categoryMatches = !selectedCategory || normalise(card.dataset.category) === selectedCategory;
        var locationMatches = !locationQuery || normalise(card.dataset.location).indexOf(locationQuery) !== -1;
        var isVisible = categoryMatches && locationMatches;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      empty.classList.toggle('is-filter-empty', visibleCount !== 0);
      count.textContent = visibleCount === 1 ? '1 trade partner found' : visibleCount + ' trade partners found';
      updateButtonStates();

      if (options && options.scroll) {
        var resultsHeading = directory.querySelector('.lux-trade-directory__results-heading');
        if (resultsHeading) resultsHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      updateDirectory({ scroll: true });
    });
    categorySelect.addEventListener('change', function () { updateDirectory(); });
    locationInput.addEventListener('input', function () { updateDirectory(); });
    form.addEventListener('reset', function () {
      window.setTimeout(function () { updateDirectory(); }, 0);
    });

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var requested = button.dataset.directoryCategoryButton || '';
        var matchingOption = Array.prototype.slice.call(categorySelect.options).find(function (option) {
          return normalise(option.value) === normalise(requested);
        });
        categorySelect.value = matchingOption ? matchingOption.value : requested;
        updateDirectory({ scroll: true });
      });
    });

    locationButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        locationInput.value = button.dataset.directoryLocationButton || '';
        updateDirectory({ scroll: true });
      });
    });

    updateDirectory();
  }

  function initialiseAllDirectories(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lux-trade-partner-directory]'), initialiseDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAllDirectories(document); });
  } else {
    initialiseAllDirectories(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialiseAllDirectories(event.target); });
})();
